const WISHLIST_STORAGE_KEY = 'wishlist';
const WISHLIST_LIMIT = 50;

function normalizeWishlistItem(item) {
  if (typeof item === 'string') {
    return {
      handle: item,
      color: ''
    };
  }

  if (
    item &&
    typeof item === 'object' &&
    typeof item.handle === 'string'
  ) {
    const normalized = {
      handle: item.handle,
      color: typeof item.color === 'string'
        ? item.color
        : ''
    };

    if (typeof item.size === 'string' && item.size) {
      normalized.size = item.size;
    }

    if (
      item.variantId != null &&
      String(item.variantId)
    ) {
      normalized.variantId = String(item.variantId);
    }

    return normalized;
  }

  return null;
}

function getWishlist() {
  try {
    const storedWishlist = JSON.parse(
      localStorage.getItem(WISHLIST_STORAGE_KEY)
    );

    if (!Array.isArray(storedWishlist)) {
      return [];
    }

    return storedWishlist
      .map(normalizeWishlistItem)
      .filter(Boolean);
  } catch (error) {
    console.error(
      'Could not read wishlist:',
      error
    );

    return [];
  }
}

function saveWishlist(wishlist) {
  localStorage.setItem(
    WISHLIST_STORAGE_KEY,
    JSON.stringify(wishlist)
  );
}

function normalizeWishlistValue(value = '') {
  return String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function getWishlistItemKey(handle, color = '') {
  return `${handle}::${normalizeWishlistValue(color)}`;
}

function isInWishlist(handle, color = '') {
  const key = getWishlistItemKey(
    handle,
    color
  );

  return getWishlist().some(item =>
    getWishlistItemKey(
      item.handle,
      item.color
    ) === key
  );
}

function addToWishlist(handle, color = '') {
  const wishlist = getWishlist();

  if (!isInWishlist(handle, color)) {
    if (wishlist.length >= WISHLIST_LIMIT) {
      openWishlistLimitDialog();
      return;
    }

    wishlist.unshift({
      handle,
      color
    });

    saveWishlist(wishlist);
  }

  updateWishlistButtons(
    handle,
    color
  );

  updateWishlistCount();

  showWishlistToast(
    'Guardado en lista'
  );

  document.dispatchEvent(
    new CustomEvent(
      'wishlist:updated',
      {
        detail: {
          wishlist: getWishlist(),
          handle,
          color,
          key: getWishlistItemKey(
            handle,
            color
          ),
          action: 'add'
        }
      }
    )
  );
}

function removeFromWishlist(
  handle,
  color = ''
) {
  const key = getWishlistItemKey(
    handle,
    color
  );

  const wishlist = getWishlist().filter(
    item =>
      getWishlistItemKey(
        item.handle,
        item.color
      ) !== key
  );

  saveWishlist(wishlist);

  updateWishlistButtons(
    handle,
    color
  );

  updateWishlistCount();

  showWishlistToast(
    'Eliminado de la lista'
  );

  document.dispatchEvent(
    new CustomEvent(
      'wishlist:updated',
      {
        detail: {
          wishlist,
          handle,
          color,
          key,
          action: 'remove'
        }
      }
    )
  );
}

function toggleWishlist(
  handle,
  color = ''
) {
  if (
    isInWishlist(
      handle,
      color
    )
  ) {
    removeFromWishlist(
      handle,
      color
    );
  } else {
    addToWishlist(
      handle,
      color
    );
  }
}

function updateWishlistButtons(
  handle = null,
  color = null
) {
  document
    .querySelectorAll(
      '[data-wishlist-button]'
    )
    .forEach(button => {
      const productHandle =
        button.dataset.wishlistHandle;

      const productColor =
        button.dataset.wishlistColor || '';

      if (!productHandle) return;

      if (
        handle !== null &&
        productHandle !== handle
      ) {
        return;
      }

      if (
        color !== null &&
        normalizeWishlistValue(
          productColor
        ) !== normalizeWishlistValue(
          color
        )
      ) {
        return;
      }

      const active =
        isInWishlist(
          productHandle,
          productColor
        );

      button.classList.toggle(
        'in-wishlist',
        active
      );

      button.setAttribute(
        'aria-pressed',
        active ? 'true' : 'false'
      );
    });
}

function isWishlistPageCount(element) {
  return Boolean(
    element &&
    element.hasAttribute('data-wishlist-page-count')
  );
}

function updateWishlistCount() {
  const count = getWishlist().length;

  document
    .querySelectorAll('[data-wishlist-count]')
    .forEach(element => {
      if (isWishlistPageCount(element)) {
        element.hidden = false;
        element.textContent = String(count);
        element.removeAttribute('data-empty');
        return;
      }

      if (count > 0) {
        element.hidden = false;
        element.textContent = String(count);
        element.removeAttribute('data-empty');
      } else {
        element.textContent = '';
        element.hidden = true;
        element.setAttribute('data-empty', '');
      }
    });
}

function wishlistPageHref() {
  const pageCount = document.querySelector(
    '[data-wishlist-count][data-wishlist-page-count]'
  );

  if (pageCount) {
    const value = pageCount.getAttribute(
      'data-wishlist-page-count'
    ) || '';

    if (value && value !== 'true') {
      return value;
    }

    const wrapped = pageCount.closest('a[href]');

    if (wrapped) {
      const href = wrapped.getAttribute('href') || '';

      if (href && !/[?&]view=wishlist\b/.test(href)) {
        return href;
      }
    }
  }

  const link = Array.from(
    document.querySelectorAll('a[href*="wishlist"]')
  ).find(anchor => {
    const href = anchor.getAttribute('href') || '';

    return (
      href &&
      !/[?&]view=wishlist\b/.test(href) &&
      !anchor.hasAttribute('data-wishlist-limit-view')
    );
  });

  return link ? link.getAttribute('href') : '';
}

function closeWishlistLimitDialog() {
  const dialog = document.querySelector(
    '[data-wishlist-limit]'
  );

  if (!dialog) return;

  dialog.hidden = true;
}

function openWishlistLimitDialog() {
  let dialog = document.querySelector(
    '[data-wishlist-limit]'
  );

  if (!dialog) {
    dialog = document.createElement('div');
    dialog.setAttribute('data-wishlist-limit', '');
    dialog.hidden = true;
    dialog.innerHTML = [
      '<div class="wishlist-limit__dialog" role="dialog" aria-modal="true" aria-labelledby="wishlist-limit-title">',
      '<div class="wishlist-limit-diagle-header"><h2 class="wishlist-limit__title" id="wishlist-limit-title">Tu lista de deseos está llena</h2><button type="button" class="wishlist-limit__close" data-wishlist-limit-close aria-label="Close">&#215;</button></div>',
      '<p class="wishlist-limit__text">Tu artículo no se ha añadido a tu lista de deseos. Puedes gestionar tu lista para eliminar algunos artículos.</p>',
      '<div class="wishlist-limit__actions">',
      '<a class="wishlist-limit__view" data-wishlist-limit-view>Gestionar lista <svg class="icon icon-chevron-right" viewBox="0 0 17 17"><path fill="currentColor" fill-rule="evenodd" d="M9.90146 8.24995 6.32573 4.67421l.84853-.84853 4.42424 4.42427-4.42424 4.42425-.84853-.8485 3.57573-3.57575Z"></path></svg></a>',
      '<button type="button" class="wishlist-limit__continue" data-wishlist-limit-continue>Seguir comprando <svg class="icon icon-chevron-right" viewBox="0 0 17 17"><path fill="currentColor" fill-rule="evenodd" d="M9.90146 8.24995 6.32573 4.67421l.84853-.84853 4.42424 4.42427-4.42424 4.42425-.84853-.8485 3.57573-3.57575Z"></path></svg></button>',
      '</div>',
      '</div>'
    ].join('');

    dialog.addEventListener('click', event => {
      if (event.target === dialog) {
        closeWishlistLimitDialog();
      }
    });

    dialog
      .querySelector('[data-wishlist-limit-close]')
      .addEventListener('click', closeWishlistLimitDialog);

    dialog
      .querySelector('[data-wishlist-limit-continue]')
      .addEventListener('click', closeWishlistLimitDialog);

    document.body.appendChild(dialog);

    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      if (!dialog.hidden) closeWishlistLimitDialog();
    });
  }

  const view = dialog.querySelector(
    '[data-wishlist-limit-view]'
  );
  const href = wishlistPageHref();

  if (view) {
    if (href) {
      view.setAttribute('href', href);
    } else {
      view.removeAttribute('href');
    }
  }

  dialog.hidden = false;
}


let wishlistToastTimer;

function showWishlistToast(message) {
  const toast =
    document.querySelector(
      '[data-wishlist-toast]'
    );

  if (!toast) return;

  toast.textContent = message;

  toast.classList.add(
    'is-visible'
  );

  clearTimeout(
    wishlistToastTimer
  );

  wishlistToastTimer =
    setTimeout(() => {
      toast.classList.remove(
        'is-visible'
      );
    }, 2500);
}

document.addEventListener(
  'click',
  event => {
    const button =
      event.target.closest(
        '[data-wishlist-button]'
      );

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const handle =
      button.dataset.wishlistHandle;

    const color =
      button.dataset.wishlistColor || '';

    if (!handle) return;

    toggleWishlist(
      handle,
      color
    );
  }
);

function getMediaColorFromAlt(
  alt = ''
) {
  const beforeType =
    String(alt)
      .split(' | ')[0]
      .trim();

  const parts =
    beforeType.split(' - ');

  if (parts.length < 2) {
    return '';
  }

  return parts
    .pop()
    .trim();
}

function cardMediaSliderIndex(slider) {
  const viewport = slider.querySelector(
    '[data-card-media-viewport]'
  );

  const slides = Array.from(
    slider.querySelectorAll(
      '[data-card-media-slide]'
    )
  );

  if (!slides.length) return 0;

  if (
    viewport &&
    typeof viewport.getBoundingClientRect ===
      'function'
  ) {
    const viewportRect =
      viewport.getBoundingClientRect();

    if (viewportRect.width > 0) {
      const viewportCenter =
        viewportRect.left +
        viewportRect.width / 2;

      let activeIndex = 0;
      let closestDistance = Infinity;

      slides.forEach((slide, index) => {
        const slideRect =
          slide.getBoundingClientRect();

        const slideCenter =
          slideRect.left +
          slideRect.width / 2;

        const distance = Math.abs(
          viewportCenter - slideCenter
        );

        if (distance < closestDistance) {
          closestDistance = distance;
          activeIndex = index;
        }
      });

      return activeIndex;
    }
  }

  const left = viewport
    ? viewport.scrollLeft || 0
    : 0;

  let activeIndex = 0;
  let closestDistance = Infinity;

  slides.forEach((slide, index) => {
    const distance = Math.abs(
      (slide.offsetLeft || 0) - left
    );

    if (distance < closestDistance) {
      closestDistance = distance;
      activeIndex = index;
    }
  });

  return activeIndex;
}

function syncCardSliderEndArrows(slider) {
  if (!slider || !slider.querySelector) return;

  const slides = slider.querySelectorAll(
    '[data-card-media-slide]'
  );

  const index = slides.length
    ? cardMediaSliderIndex(slider)
    : 0;

  const previousButton = slider.querySelector(
    '[data-card-media-prev]'
  );

  const nextButton = slider.querySelector(
    '[data-card-media-next]'
  );

  if (previousButton) {
    previousButton.hidden =
      slides.length === 0 || index <= 0;
  }

  if (nextButton) {
    nextButton.hidden =
      slides.length === 0 ||
      index >= slides.length - 1;
  }
}

function syncCardSliders(scope) {
  const root =
    scope && scope.querySelectorAll
      ? scope
      : document;

  root
    .querySelectorAll(
      '[data-card-media-slider]'
    )
    .forEach(syncCardSliderEndArrows);
}

function scheduleCardSliderEndArrows(slider) {
  syncCardSliderEndArrows(slider);

  window.setTimeout(() => {
    syncCardSliderEndArrows(slider);
  }, 350);
}

function bindCardSliderArrowSync() {
  if (
    !document.getElementById(
      'card-slider-end-arrow-styles'
    )
  ) {
    const style =
      document.createElement('style');

    style.id = 'card-slider-end-arrow-styles';

    style.textContent =
      '.card-media-slider__button[hidden]{display:none !important}';

    (
      document.head ||
      document.documentElement
    ).appendChild(style);
  }

  const current =
    window.updateCardMediaButtons;

  if (
    typeof current === 'function' &&
    !current.syncsEndArrows
  ) {
    const wrapped = function(slider) {
      current(slider);
      syncCardSliderEndArrows(slider);
    };

    wrapped.syncsEndArrows = true;
    window.updateCardMediaButtons = wrapped;
  }

  syncCardSliders(document);
}

function filterWishlistCardMedia(
  card,
  color
) {
  if (!card || !color) return;

  const wantedColor =
    normalizeWishlistValue(color);

  const slider =
    card.querySelector(
      '[data-card-media-slider]'
    );

  if (!slider) return;

  const slides =
    Array.from(
      slider.querySelectorAll(
        '[data-card-media-slide]'
      )
    );

  const matches = slides.filter(slide =>
    slideMatchesWishlistColor(
      slide,
      wantedColor
    )
  );

  if (!matches.length) {
    console.warn(
      `No wishlist images matched color "${color}".`
    );

    return;
  }

  slides.forEach(slide => {
    if (!matches.includes(slide)) {
      slide.remove();
    }
  });

  const viewport =
    slider.querySelector(
      '[data-card-media-viewport]'
    );

  if (viewport) {
    viewport.scrollLeft = 0;
  }

  if (typeof updateCardMediaButtons === 'function') {
    updateCardMediaButtons(slider);
  }

  syncCardSliderEndArrows(slider);
}


function wishlistCardFrom(node) {
  if (!node || !node.closest) return null;

  return node.closest(
    '[data-wishlist-product]'
  );
}

function wishlistLowStockMax(selector) {
  const max = Number(
    selector && selector.dataset.lowStockMax
  );

  if (Number.isFinite(max) && max >= 1) {
    return max;
  }

  return 3;
}

function wishlistInventoryQuantity(option) {
  if (
    !option ||
    option.dataset.inventoryQuantity == null ||
    option.dataset.inventoryQuantity === ''
  ) {
    return null;
  }

  const quantity = Number(
    option.dataset.inventoryQuantity
  );

  return Number.isFinite(quantity)
    ? quantity
    : null;
}

function wishlistStockKind(option) {
  const quantity = wishlistInventoryQuantity(option);

  if (quantity == null) return '';
  if (quantity === 0) return 'out';
  if (quantity === 1) return 'last';
  if (quantity > 1 && quantity <= 3) return 'low';

  return '';
}

function sizeNeedsStockDot(option, lowStockMax) {
  const quantity = wishlistInventoryQuantity(option);

  if (quantity == null || quantity < 1) return false;

  return quantity <= lowStockMax;
}

function updateWishlistStockDots(selector) {
  if (!selector) return;

  const max = wishlistLowStockMax(selector);

  selector
    .querySelectorAll(
      '[data-wishlist-size-option]'
    )
    .forEach(option => {
      const dot = option.querySelector(
        '[data-wishlist-stock-dot]'
      );

      if (!dot) return;

      dot.hidden = !sizeNeedsStockDot(
        option,
        max
      );
    });
}

function syncWishlistStockNotice(card, option) {
  if (!card) return;

  const kind = wishlistStockKind(option);

  card
    .querySelectorAll(
      '.variant-info .stock-notification'
    )
    .forEach(notice => {
      notice.hidden =
        (notice.dataset.wishlistStock || '') !== kind;
    });
}

function syncSelectedStockDot(selector, option) {
  if (!selector) return;

  const needsDot = sizeNeedsStockDot(
    option,
    wishlistLowStockMax(selector)
  );

  const dot = selector.querySelector(
    '[data-wishlist-selected-stock-dot]'
  );

  if (dot) {
    dot.hidden = !needsDot;
  }

  syncWishlistStockNotice(
    wishlistCardFrom(selector),
    option
  );
}

function updateWishlistPrice(card, option) {
  if (!card || !option) return;

  const onSale = option.dataset.onSale === 'true';

  card
    .querySelectorAll(
      '[data-wishlist-sale-badge]'
    )
    .forEach(badge => {
      badge.hidden = !onSale;
    });

  const price = card.querySelector(
    '[data-wishlist-price]'
  );

  if (!price) return;

  const current = option.dataset.price || '';
  const compare = onSale
    ? (option.dataset.compareAtPrice || '')
    : '';

  price.classList.toggle(
    'price--on-sale',
    onSale
  );

  const regular = price.querySelector(
    '[data-wishlist-price-current]'
  );

  const sale = price.querySelector(
    '[data-wishlist-price-sale]'
  );

  const compareEl = price.querySelector(
    '[data-wishlist-price-compare]'
  );

  if (regular) regular.textContent = current;
  if (sale) sale.textContent = current;
  if (compareEl) compareEl.textContent = compare;
}

function setWishlistPurchaseState(card, option) {
  if (!card) return;

  const unavailable = Boolean(
    option &&
    option.dataset.variantAvailable !== 'true'
  );

  card.classList.toggle(
    'is-unavailable',
    unavailable
  );

  const button = card.querySelector(
    '[data-wishlist-move-to-cart]'
  );

  if (!button) return;

  const label = button.querySelector(
    '[data-wishlist-cart-label]'
  );

  const icon = button.querySelector(
    '[data-wishlist-cart-icon]'
  );

  const textNode = label
    ? null
    : Array.from(button.childNodes).find(node =>
      node.nodeType === Node.TEXT_NODE &&
      node.textContent.trim()
    );

  if (!button.dataset.wishlistCartText) {
    button.dataset.wishlistCartText = label
      ? label.textContent.trim()
      : (
        textNode
          ? textNode.textContent.trim()
          : ''
      );
  }

  button.classList.toggle(
    'notify-button',
    unavailable
  );

  const nextLabel = unavailable
    ? 'Notificarme'
    : (
      button.dataset.wishlistCartText ||
      ''
    );

  if (label) {
    label.textContent = nextLabel;
  } else if (textNode) {
    textNode.textContent = nextLabel;
  }

  if (icon) {
    icon.hidden = unavailable;
  }
}

function syncWishlistVariantLinks(card, option) {
  if (!card) return;

  const handle = card.dataset.productHandle;
  const color = card.dataset.wishlistColor || '';
  const variantId = option && option.dataset.variantId
    ? option.dataset.variantId
    : '';

  card.querySelectorAll('a[href]').forEach(link => {
    try {
      const url = new URL(
        link.href,
        window.location.origin
      );

      if (
        !handle ||
        !url.pathname.includes(
          `/products/${handle}`
        )
      ) {
        return;
      }

      if (color) {
        url.searchParams.set(
          'color',
          color
        );
      }

      if (variantId) {
        url.searchParams.set(
          'variant',
          variantId
        );
      }

      link.href =
        url.pathname +
        url.search +
        url.hash;
    } catch (error) {
    }
  });
}

function showWishlistColorSwatch(card, color) {
  if (!card) return;

  const colorValue = card.querySelector(
    '.wishlist-color-value'
  );

  if (colorValue && color) {
    const paragraph =
      colorValue.querySelector('p') ||
      colorValue;

    paragraph.textContent = color;
  }

  const line = card.querySelector(
    '[data-wishlist-color-line]'
  );

  const name = card.querySelector(
    '[data-wishlist-color-name]'
  );

  const swatch = card.querySelector(
    '[data-wishlist-swatch-img]'
  );

  const source = card.querySelector(
    '[data-wishlist-swatch-source]'
  );

  const displayColor = String(color || '').trim();

  if (name) {
    name.textContent = displayColor;
  }

  if (line) {
    line.hidden = !displayColor;
  }

  let url = '';

  if (source && source.content && displayColor) {
    const wanted = normalizeWishlistValue(
      displayColor
    );

    const match = Array.from(
      source.content.querySelectorAll(
        '[data-wishlist-swatch]'
      )
    ).find(node =>
      normalizeWishlistValue(
        node.dataset.colorHandle || ''
      ) === wanted
    );

    if (match) {
      url = match.dataset.swatchUrl || '';
    }
  }

  if (swatch) {
    swatch.style.backgroundImage = url
      ? `url("${url.replace(/"/g, '\\"')}")`
      : '';

    swatch.hidden = !url;
  }
}

function slideMatchesWishlistColor(slide, wantedColor) {
  if (!wantedColor) return true;

  const image = slide.querySelector('img');

  const values = [
    getMediaColorFromAlt(
      image ? image.alt : ''
    ),
    slide.dataset.mediaColor || '',
    slide.dataset.mediaColorHandle || ''
  ];

  return values.some(value =>
    value &&
    normalizeWishlistValue(value) === wantedColor
  );
}

function openWishlistNotifyDrawer(card, option) {
  const drawer = document.querySelector(
    '.notify-drawer'
  );

  const handle = card.dataset.productHandle || '';

  const variantId =
    (option && option.dataset.variantId) ||
    card.querySelector(
      '[data-wishlist-selected-variant]'
    )?.value ||
    '';

  const size = (option && option.dataset.size) || '';

  const color =
    card.dataset.wishlistColor ||
    (option && option.dataset.variantColor) ||
    '';

  if (
    !drawer &&
    typeof window.openNotifyDrawer !== 'function'
  ) {
    console.error(
      'Notify drawer is not on this page. Render snippets/notify-drawer.liquid once from the header. snippets/header-search.liquid already renders it for the rest of the site.'
    );

    return;
  }

  if (drawer) {
    const slot = drawer.querySelector(
      '[data-notify-product-data]'
    );

    const source = card.querySelector(
      '[data-notify-product-data]'
    );

    if (slot && source) {
      if (drawer._notifyOriginalJson == null) {
        drawer._notifyOriginalJson = slot.textContent;
      }

      slot.textContent = source.textContent;
      drawer._notifyProductData = undefined;
    }

    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
  }

  const payload = {
    productHandle: handle,
    variantId: variantId,
    size: size,
    color: color
  };

  if (typeof window.openNotifyDrawer === 'function') {
    window.openNotifyDrawer(payload);
    return;
  }

  drawer.dataset.productHandle = handle;
  drawer.dataset.variantId = variantId;
  drawer.dataset.size = size;
  drawer.dataset.color = color;

  const sizeOutput =
    drawer.querySelector('[data-selected-value]') ||
    drawer.querySelector('[data-notify-size]');

  if (sizeOutput) {
    sizeOutput.textContent = size;
  }

  const sizeRow = drawer.querySelector(
    '[data-selected-size-row]'
  );

  if (sizeRow) {
    sizeRow.hidden = !size;
  }

  const colorOutput = drawer.querySelector(
    '[data-selected-color]'
  );

  if (colorOutput) {
    colorOutput.textContent = color;
  }

  const colorRow = drawer.querySelector(
    '[data-selected-color-row]'
  );

  if (colorRow) {
    colorRow.hidden = !color;
  }

  drawer.classList.add('active');
}

function rememberWishlistSelection(
  handle,
  color,
  size,
  variantId
) {
  if (!handle) return;

  const key = getWishlistItemKey(
    handle,
    color
  );

  const wishlist = getWishlist();
  let changed = false;

  const next = wishlist.map(item => {
    if (
      getWishlistItemKey(
        item.handle,
        item.color
      ) !== key
    ) {
      return item;
    }

    const nextItem = {
      handle: item.handle,
      color: item.color || ''
    };

    if (size) {
      nextItem.size = size;
    }

    if (variantId) {
      nextItem.variantId = String(variantId);
    }

    if (
      (item.size || '') !== (nextItem.size || '') ||
      (item.variantId || '') !== (nextItem.variantId || '')
    ) {
      changed = true;
    }

    return nextItem;
  });

  if (!changed) return;

  saveWishlist(next);
}

function selectWishlistSizeOption(
  selector,
  option
) {
  if (
    !selector ||
    !option
  ) {
    return;
  }

  const card =
    wishlistCardFrom(selector);

  const label =
    selector.querySelector(
      '[data-wishlist-size-label]'
    );

  const input =
    (card &&
      card.querySelector(
        '[data-wishlist-selected-variant]'
      )) ||
    selector.querySelector(
      '[data-wishlist-selected-variant]'
    );

  selector
    .querySelectorAll(
      '[data-wishlist-size-option]'
    )
    .forEach(item => {
      const isSelected =
        item === option;

      item.classList.toggle(
        'is-selected',
        isSelected
      );

      item.setAttribute(
        'aria-selected',
        isSelected ? 'true' : 'false'
      );
    });

  if (label) {
    label.textContent =
      option.dataset.size || '';
  }

  const toggle =
    selector.querySelector(
      '[data-wishlist-size-toggle]'
    );

  if (toggle) {
    [
      'is-low-stock',
      'is-last-stock',
      'is-out-of-stock',
      'is-disabled'
    ].forEach(name => {
      toggle.classList.toggle(
        name,
        option.classList.contains(name)
      );
    });
  }

  if (input) {
    input.value =
      option.dataset.variantId || '';
  }

  if (card) {
    updateWishlistPrice(card, option);
    setWishlistPurchaseState(card, option);
    syncWishlistVariantLinks(card, option);
  }

  syncSelectedStockDot(selector, option);

  if (card) {
    rememberWishlistSelection(
      card.dataset.productHandle,
      card.dataset.wishlistColor || '',
      option.dataset.size || '',
      option.dataset.variantId || ''
    );
  }
}


function configureWishlistSizeSelector(
  card,
  color,
  savedSelection
) {
  const selector =
    card.querySelector(
      '[data-wishlist-size-selector]'
    ) ||
    card.querySelector(
      '[data-wishlist-variant-list]'
    );

  if (!selector) return;

  const wantedColor =
    normalizeWishlistValue(color);

  const options =
    Array.from(
      selector.querySelectorAll(
        '[data-wishlist-size-option]'
      )
    );

  const seenSizes =
    new Set();

  options.forEach(option => {
    const optionColor =
      option.dataset.variantColorHandle ||
      normalizeWishlistValue(
        option.dataset.variantColor || ''
      );

    const normalizedOptionColor =
      normalizeWishlistValue(
        optionColor
      );

    const optionSize =
      normalizeWishlistValue(
        option.dataset.size || ''
      );

    if (
      wantedColor &&
      normalizedOptionColor !== wantedColor
    ) {
      option.remove();
      return;
    }

    if (seenSizes.has(optionSize)) {
      option.remove();
      return;
    }

    seenSizes.add(optionSize);

    const isAvailable =
      option.dataset.variantAvailable ===
      'true';

    option.disabled = false;

    option.classList.toggle(
      'is-disabled',
      !isAvailable
    );
  });

  const remainingOptions =
    Array.from(
      selector.querySelectorAll(
        '[data-wishlist-size-option]'
      )
    );

  updateWishlistStockDots(selector);

  const savedVariant =
    savedSelection && savedSelection.variantId
      ? String(savedSelection.variantId)
      : '';

  const savedSize =
    savedSelection && savedSelection.size
      ? normalizeWishlistValue(
        savedSelection.size
      )
      : '';

  const savedOption =
    (
      savedVariant &&
      remainingOptions.find(option =>
        option.dataset.variantId ===
        savedVariant
      )
    ) ||
    (
      savedSize &&
      remainingOptions.find(option =>
        normalizeWishlistValue(
          option.dataset.size || ''
        ) === savedSize
      )
    ) ||
    null;

  const firstAvailableOption =
    remainingOptions.find(
      option =>
        option.dataset.variantAvailable ===
        'true'
    );

  const chosen =
    savedOption ||
    firstAvailableOption ||
    remainingOptions[0];

  if (chosen) {
    selectWishlistSizeOption(
      selector,
      chosen
    );
  } else {
    const label =
      selector.querySelector(
        '[data-wishlist-size-label]'
      );

    const input =
      card.querySelector(
        '[data-wishlist-selected-variant]'
      );

    if (label) {
      label.textContent = '';
    }

    if (input) {
      input.value = '';
    }
  }
}


function configureWishlistCard(
  card,
  item
) {
  if (!card || !item) return;

  const {
    handle,
    color
  } = item;

  const key =
    getWishlistItemKey(
      handle,
      color
    );

  card.dataset.productHandle =
    handle;

  card.dataset.wishlistColor =
    color || '';

  card.dataset.wishlistKey =
    key;

  card
    .querySelectorAll(
      '[data-wishlist-button]'
    )
    .forEach(button => {
      button.dataset.wishlistHandle =
        handle;

      button.dataset.wishlistColor =
        color || '';
    });

  filterWishlistCardMedia(
    card,
    color
  );

  configureWishlistSizeSelector(
    card,
    color,
    item
  );

  showWishlistColorSwatch(
    card,
    color
  );

  const selected =
    card.querySelector(
      '[data-wishlist-size-option].is-selected'
    );

  syncWishlistVariantLinks(
    card,
    selected
  );
}


async function loadWishlistProduct(
  item
) {
  const handle =
    item.handle;

  const url =
    `${window.Shopify.routes.root}products/${encodeURIComponent(handle)}?view=wishlist`;

  try {
    const response =
      await fetch(
        url,
        {
          credentials:
            'same-origin'
        }
      );

    if (!response.ok) {
      console.error(
        `Wishlist product failed: ${handle}`,
        response.status,
        response.statusText
      );

      return null;
    }

    const html =
      await response.text();

    const parsedDocument =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const card =
      parsedDocument.querySelector(
        '[data-wishlist-product]'
      );

    if (!card) {
      console.error(
        `No [data-wishlist-product] found for "${handle}".`
      );

      return null;
    }

    configureWishlistCard(
      card,
      item
    );

    return {
      item,
      card
    };
  } catch (error) {
    console.error(
      `Error loading wishlist product "${handle}":`,
      error
    );

    return null;
  }
}

async function initWishlistPage() {
  const grid =
    document.querySelector(
      '[data-wishlist-grid]'
    );

  if (!grid) return;

  const emptyState =
    document.querySelector(
      '[data-wishlist-empty]'
    );

  const wishlist =
    getWishlist();

  if (!wishlist.length) {
    grid.innerHTML = '';

    if (emptyState) {
      emptyState.hidden = false;
    }

    return;
  }

  if (emptyState) {
    emptyState.hidden = true;
  }

  grid.innerHTML = '';

  const results =
    await Promise.all(
      wishlist.map(
        item =>
          loadWishlistProduct(
            item
          )
      )
    );

  let renderedProducts = 0;

  results.forEach(result => {
    if (!result) return;

    grid.appendChild(
      result.card
    );

    renderedProducts++;
  });

  if (!renderedProducts) {
    console.error(
      'Wishlist has saved products, but none of the wishlist product templates returned [data-wishlist-product].'
    );
  }

  updateWishlistButtons();

  if (
    typeof initializeCardMediaSliders ===
    'function'
  ) {
    initializeCardMediaSliders(
      grid
    );
  }
}

document.addEventListener(
  'wishlist:updated',
  async event => {
    const grid =
      document.querySelector(
        '[data-wishlist-grid]'
      );

    if (!grid) return;

    const detail = event.detail || {};
    const action = detail.action;
    const key = detail.key;

    if (action === 'remove') {
      const card =
        Array.from(
          grid.querySelectorAll(
            '[data-wishlist-product]'
          )
        ).find(item =>
          item.dataset.wishlistKey === key
        );

      if (card) {
        card.remove();
      }

      if (!getWishlist().length) {
        const emptyState =
          document.querySelector(
            '[data-wishlist-empty]'
          );

        if (emptyState) {
          emptyState.hidden = false;
        }
      }

      return;
    }

    if (action !== 'add') return;

    const already =
      Array.from(
        grid.querySelectorAll(
          '[data-wishlist-product]'
        )
      ).find(item =>
        item.dataset.wishlistKey === key
      );

    if (already) return;

    const result =
      await loadWishlistProduct({
        handle: detail.handle,
        color: detail.color || ''
      });

    if (!result || !result.card) return;

    const duplicate =
      Array.from(
        grid.querySelectorAll(
          '[data-wishlist-product]'
        )
      ).find(item =>
        item.dataset.wishlistKey ===
        result.card.dataset.wishlistKey
      );

    if (duplicate) return;

    const emptyState =
      document.querySelector(
        '[data-wishlist-empty]'
      );

    if (emptyState) {
      emptyState.hidden = true;
    }

    grid.appendChild(result.card);

    updateWishlistButtons();
  }
);

document.addEventListener(
  'click',
  event => {
    const toggle =
      event.target.closest(
        '[data-wishlist-size-toggle]'
      );

    const option =
      event.target.closest(
        '[data-wishlist-size-option]'
      );

    if (toggle) {
      const selector =
        toggle.closest(
          '[data-wishlist-size-selector]'
        );

      if (!selector) return;

      if (selector.hasAttribute('data-wishlist-size-static')) {
        return;
      }

      event.preventDefault();

      const isOpen =
        selector.classList.contains(
          'is-open'
        );

      document
        .querySelectorAll(
          '[data-wishlist-size-selector].is-open'
        )
        .forEach(item => {
          if (item === selector) {
            return;
          }

          item.classList.remove(
            'is-open'
          );

          const itemToggle =
            item.querySelector(
              '[data-wishlist-size-toggle]'
            );

          if (itemToggle) {
            itemToggle.setAttribute(
              'aria-expanded',
              'false'
            );
          }
        });

      selector.classList.toggle(
        'is-open',
        !isOpen
      );

      toggle.setAttribute(
        'aria-expanded',
        !isOpen ? 'true' : 'false'
      );

      return;
    }

    if (option) {
      event.preventDefault();

      const selector =
        option.closest(
          '[data-wishlist-size-selector]'
        );

      if (!selector) return;

      selectWishlistSizeOption(
        selector,
        option
      );

      selector.classList.remove(
        'is-open'
      );

      const toggleButton =
        selector.querySelector(
          '[data-wishlist-size-toggle]'
        );

      if (toggleButton) {
        toggleButton.setAttribute(
          'aria-expanded',
          'false'
        );
      }

      return;
    }

    document
      .querySelectorAll(
        '[data-wishlist-size-selector].is-open'
      )
      .forEach(selector => {
        selector.classList.remove(
          'is-open'
        );

        const toggleButton =
          selector.querySelector(
            '[data-wishlist-size-toggle]'
          );

        if (toggleButton) {
          toggleButton.setAttribute(
            'aria-expanded',
            'false'
          );
        }
      });
  }
);

document.addEventListener(
  'click',
  async event => {
    const button =
      event.target.closest(
        '[data-wishlist-move-to-cart]'
      );

    if (!button) return;

    event.preventDefault();

    const card =
      button.closest(
        '[data-wishlist-product]'
      );

    if (!card) return;

    const selectedOption =
      card.querySelector(
        '[data-wishlist-size-option].is-selected'
      );

    const notify =
      button.classList.contains(
        'notify-button'
      ) ||
      (
        selectedOption &&
        selectedOption.dataset.variantAvailable !==
          'true'
      );

    if (notify) {
      event.stopPropagation();
      event.stopImmediatePropagation();

      openWishlistNotifyDrawer(
        card,
        selectedOption
      );

      return;
    }

    const variantInput =
      card.querySelector(
        '[data-wishlist-selected-variant]'
      );

    const variantId =
      variantInput?.value || '';

    if (!variantId) {
      console.error(
        'No variant selected for wishlist add to cart.'
      );

      return;
    }

    button.disabled = true;

    try {
      const response =
        await fetch(
          `${window.Shopify.routes.root}cart/add.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type':
                'application/json',
              'Accept':
                'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: Number(
                    variantId
                  ),
                  quantity: 1
                }
              ],
              sections: wishlistCartSectionIds(),
              sections_url: window.location.pathname
            })
          }
        );

      if (!response.ok) {
        const error =
          await response
            .json()
            .catch(() => null);

        throw new Error(
          error?.description ||
          `Cart add failed: ${response.status}`
        );
      }

      const handle =
        card.dataset.productHandle;

      const color =
        card.dataset.wishlistColor || '';

      const added = await response.json();

      removeFromWishlist(
        handle,
        color
      );

      const count = await readCartItemCount(added);

      applyCartIconSection(added);
      writeCartCounters(count);

      document.dispatchEvent(
        new CustomEvent(
          'cart:refresh'
        )
      );

      if (
        typeof publish === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.cartUpdate
      ) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'wishlist',
          cartData: {
            item_count: count
          }
        });
      }
    } catch (error) {
      console.error(
        'Could not move wishlist item to cart:',
        error
      );
    } finally {
      button.disabled = false;
    }
  }
);

document.addEventListener(
  'scroll',
  event => {
    const viewport =
      event.target &&
      event.target.closest &&
      event.target.closest(
        '[data-card-media-viewport]'
      );

    if (!viewport) return;

    const slider = viewport.closest(
      '[data-card-media-slider]'
    );

    if (!slider) return;

    syncCardSliderEndArrows(slider);
  },
  true
);

document.addEventListener(
  'click',
  event => {
    const button =
      event.target &&
      event.target.closest &&
      event.target.closest(
        '[data-card-media-prev], [data-card-media-next]'
      );

    if (!button) return;

    const slider = button.closest(
      '[data-card-media-slider]'
    );

    if (!slider) return;

    scheduleCardSliderEndArrows(slider);
  }
);

document.addEventListener(
  'pointerup',
  event => {
    const viewport =
      event.target &&
      event.target.closest &&
      event.target.closest(
        '[data-card-media-viewport]'
      );

    if (!viewport) return;

    const slider = viewport.closest(
      '[data-card-media-slider]'
    );

    if (!slider) return;

    scheduleCardSliderEndArrows(slider);
  }
);

document.addEventListener(
  'shopify:section:load',
  event => {
    bindCardSliderArrowSync();
    syncCardSliders(event.target);
  }
);

function initWishlist() {
  updateWishlistButtons();
  updateWishlistCount();
  initWishlistPage();
  bindCardSliderArrowSync();
}

if (
  document.readyState ===
  'loading'
) {
  document.addEventListener(
    'DOMContentLoaded',
    initWishlist
  );
} else {
  initWishlist();
}

// Megamenu
function initMegaMenu() {
  const megaTriggers = document.querySelectorAll('[data-megamenu-target]');
  const megaDrawers = document.querySelectorAll('.megamenu-drawer');
  const headerMenu = document.querySelector('.header__inline-menu');
  const mediaQuery = window.matchMedia('(max-width: 1023px)');

  let activeTrigger = null;
  let activeDrawer = null;
  let closeTimer = null;
  let pointerX = 0;
  let pointerY = 0;

  function setFirstMobileSubmenu(drawer) {
    if (!mediaQuery.matches) return;

    const defaultColumn = drawer.querySelector(
      '.mega-menu-wrapper--col-right-default'
    );

    const secondLevelList = drawer.querySelector(
      '.mega-menu--list.second-level'
    );

    if (!secondLevelList) return;

    const levelTwoButtons = secondLevelList.querySelectorAll(
      ':scope > li > .mega-menu__link.mega-menu__link--level-2'
    );

    const submenuColumns = drawer.querySelectorAll(
      '.mega-menu-wrapper--col-right-submenu'
    );

    levelTwoButtons.forEach(button => {
      button.classList.remove('active');
    });

    submenuColumns.forEach(column => {
      column.classList.remove('active');
    });

    if (defaultColumn) {
      defaultColumn.classList.remove('active');
    }

    const firstTrigger = secondLevelList.querySelector(
      ':scope > li > .mega-menu__link.mega-menu__link--level-2'
    );

    if (!firstTrigger) return;

    const firstItem = firstTrigger.closest('li');

    const firstSubmenu = firstItem?.querySelector(
      '.mega-menu-wrapper--col-right-submenu'
    );

    firstTrigger.classList.add('active');

    if (firstSubmenu) {
      firstSubmenu.classList.add('active');
    }
  }

  function closeAllMegaMenus() {
    megaDrawers.forEach(drawer => {
      drawer.classList.remove('open');
    });

    megaTriggers.forEach(trigger => {
      trigger.classList.remove('active');
    });

    activeTrigger = null;
    activeDrawer = null;
  }

  function openMegaMenu(trigger) {
    const targetId = trigger.dataset.megamenuTarget;

    const targetDrawer = document.querySelector(
      `.megamenu-drawer#${CSS.escape(targetId)}`
    );

    if (!targetDrawer) return;

    clearTimeout(closeTimer);

    if (activeDrawer !== targetDrawer) {
      closeAllMegaMenus();
    }

    trigger.classList.add('active');
    targetDrawer.classList.add('open');

    activeTrigger = trigger;
    activeDrawer = targetDrawer;

    if (mediaQuery.matches) {
      setFirstMobileSubmenu(targetDrawer);
    }
  }

  function isInsideMegaMenuArea(element) {
    if (!element) return false;

    if (headerMenu?.contains(element)) {
      return true;
    }

    return Array.from(megaDrawers).some(drawer => {
      return drawer.contains(element);
    });
  }

  function scheduleCloseMegaMenu() {
    clearTimeout(closeTimer);

    closeTimer = setTimeout(() => {
      const element = document.elementFromPoint(pointerX, pointerY);

      if (!isInsideMegaMenuArea(element)) {
        closeAllMegaMenus();
      }
    }, 50);
  }

  document.addEventListener('pointermove', event => {
    pointerX = event.clientX;
    pointerY = event.clientY;
  });

  megaTriggers.forEach(trigger => {
    trigger.addEventListener('mouseenter', () => {
      openMegaMenu(trigger);
    });
  });

  if (headerMenu) {
    headerMenu.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
    });

    headerMenu.addEventListener('mouseleave', event => {
      if (isInsideMegaMenuArea(event.relatedTarget)) {
        return;
      }

      scheduleCloseMegaMenu();
    });
  }

  megaDrawers.forEach(drawer => {
    drawer.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
    });

    drawer.addEventListener('mouseleave', event => {
      if (isInsideMegaMenuArea(event.relatedTarget)) {
        return;
      }

      scheduleCloseMegaMenu();
    });

    const defaultColumn = drawer.querySelector(
      '.mega-menu-wrapper--col-right-default'
    );

    const secondLevelList = drawer.querySelector(
      '.mega-menu--list.second-level'
    );

    if (defaultColumn && secondLevelList) {
      const levelTwoButtons = secondLevelList.querySelectorAll(
        ':scope > li > .mega-menu__link.mega-menu__link--level-2'
      );

      const submenuColumns = drawer.querySelectorAll(
        '.mega-menu-wrapper--col-right-submenu'
      );

      secondLevelList.querySelectorAll(':scope > li').forEach(item => {
        const trigger = item.querySelector(
          ':scope > .mega-menu__link.mega-menu__link--level-2'
        );

        const submenuColumn = item.querySelector(
          '.mega-menu-wrapper--col-right-submenu'
        );

        if (!trigger || !submenuColumn) return;

        function activateSubmenu() {
          defaultColumn.classList.remove('active');

          submenuColumns.forEach(column => {
            column.classList.remove('active');
          });

          levelTwoButtons.forEach(button => {
            button.classList.remove('active');
          });

          trigger.classList.add('active');
          submenuColumn.classList.add('active');
        }

        trigger.addEventListener('mouseenter', activateSubmenu);
        trigger.addEventListener('focus', activateSubmenu);
        trigger.addEventListener('click', activateSubmenu);
      });

      secondLevelList.addEventListener('mouseleave', () => {
        if (mediaQuery.matches) return;

        submenuColumns.forEach(column => {
          column.classList.remove('active');
        });

        levelTwoButtons.forEach(button => {
          button.classList.remove('active');
        });

        defaultColumn.classList.add('active');
      });
    }
  });

  if (mediaQuery.matches) {
    megaDrawers.forEach(drawer => {
      setFirstMobileSubmenu(drawer);
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMegaMenu);
} else {
  initMegaMenu();
}

// Dawn already re-renders the product section on variant change.
// Do not fetch it again or replace product-info. That second swap flashes two forms.
function syncStickyProductBar(productInfo, sourceHtml) {
  if (!productInfo) return;

  const sectionId = productInfo.dataset.section;
  const mainPrice = sectionId
    ? productInfo.querySelector(`[id="price-${sectionId}"]`)
    : null;
  const stickyPrice = productInfo.querySelector('[data-sticky-price]');

  if (mainPrice && stickyPrice && mainPrice !== stickyPrice) {
    stickyPrice.innerHTML = mainPrice.innerHTML;
  }

  if (sourceHtml && typeof sourceHtml.querySelector === 'function') {
    const nextToggle = sourceHtml.querySelector('.sticky-product-form .color-option-toggle');
    const currentToggle = productInfo.querySelector('.sticky-product-form .color-option-toggle');

    if (nextToggle && currentToggle) {
      currentToggle.innerHTML = nextToggle.innerHTML;
    }
  }

  const liveButton = productInfo.querySelector(
    '.buy-buttons-desktop [name="add"], .buy-buttons-desktop product-form [type="submit"]'
  );
  const stickyButton = productInfo.querySelector('[data-sticky-submit]');

  if (liveButton && stickyButton) {
    stickyButton.classList.toggle('notify-button', liveButton.classList.contains('notify-button'));

    const liveLabel = liveButton.querySelector('span');
    const stickyLabel = stickyButton.querySelector('span');

    if (liveLabel && stickyLabel) {
      stickyLabel.textContent = liveLabel.textContent;
    }
  }
}

function refreshProductAfterDawnUpdate(sectionId, sourceHtml) {
  collapseOpenQuickAddVariantDuplicates();

  document.querySelectorAll('product-info').forEach((productInfo) => {
    if (!sectionId) return;

    const matchesSection = productInfo.dataset.section === String(sectionId)
      || productInfo.dataset.originalSection === String(sectionId);

    if (!matchesSection) return;

    syncStickyProductBar(productInfo, sourceHtml);
  });

  if (typeof initProductMediaDots === 'function') {
    initProductMediaDots();
  }

  if (typeof initProductGalleryZoom === 'function') {
    initProductGalleryZoom();
  }

  if (typeof updateWishlistButtons === 'function') {
    updateWishlistButtons();
  }
}

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const payload = event && event.data ? event.data : {};
    refreshProductAfterDawnUpdate(payload.sectionId, payload.html || null);
  });
}

function syncStickyProductBars() {
  document.querySelectorAll('product-info').forEach((productInfo) => {
    syncStickyProductBar(productInfo);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncStickyProductBars);
} else {
  syncStickyProductBars();
}

// Dawn inserts the new variant-selects before the old one and leaves the old
// one for 500ms. Inside an open quick-add modal that paints two size rows.
// Drop the extra before the next paint. Do not fetch or replace product-info.
function quickAddNodeIsSuppressed(node) {
  let current = node;

  while (current && current.nodeType === 1) {
    if (current.style && current.style.display === 'none') return true;
    current = current.parentElement;
  }

  return false;
}

function keepFreshQuickAddNode(nodes) {
  const list = Array.from(nodes);
  if (list.length < 2) return;

  const keep = list.find((node) => !quickAddNodeIsSuppressed(node)) || list[0];

  list.forEach((node) => {
    if (node !== keep) node.remove();
  });
}

function collapseQuickAddVariantDuplicates(modal) {
  if (!modal) return;

  keepFreshQuickAddNode(modal.querySelectorAll('variant-selects'));

  const pillsByName = new Map();

  modal.querySelectorAll('.product-form__input--pill').forEach((pill) => {
    const input = pill.querySelector('input[name]');
    const key = input ? input.getAttribute('name') : 'size';
    const group = pillsByName.get(key);

    if (group) {
      group.push(pill);
    } else {
      pillsByName.set(key, [pill]);
    }
  });

  pillsByName.forEach((pills) => {
    keepFreshQuickAddNode(pills);
  });
}

function collapseOpenQuickAddVariantDuplicates() {
  document.querySelectorAll('.quick-add-modal[open], .quick-add-modal.active').forEach((modal) => {
    collapseQuickAddVariantDuplicates(modal);
  });
}

function watchQuickAddVariantDuplicates() {
  collapseOpenQuickAddVariantDuplicates();

  const root = document.body || document.documentElement;
  if (!root || root.dataset.quickAddVariantWatch === 'true') return;

  root.dataset.quickAddVariantWatch = 'true';

  const observer = new MutationObserver(() => {
    collapseOpenQuickAddVariantDuplicates();
  });

  observer.observe(root, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', watchQuickAddVariantDuplicates);
} else {
  watchQuickAddVariantDuplicates();
}

// Collapsible content
var coll = document.getElementsByClassName("collapsible-btn");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  });
}

// Free shipping bar
document.addEventListener('DOMContentLoaded', () => {
  const bar = document.querySelector('[data-free-shipping-bar]');
  if (!bar) return;

  const threshold = parseInt(bar.dataset.threshold, 10);
  const text = bar.querySelector('[data-free-shipping-text]');
  const fill = bar.querySelector('[data-free-shipping-fill]');

  async function updateFreeShipping() {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    const total = cart.total_price;

    if (total >= threshold) {
      text.textContent = '¡Ya tienes envío gratis!';
      fill.style.width = '100%';
    } else {
      const remaining = threshold - total;

      const formatted = '$' + Math.round(remaining / 100);

      text.textContent = `Te faltan ${formatted} para envío gratis`;
      fill.style.width = `${(total / threshold) * 100}%`;
    }
  }

  updateFreeShipping();
  
  document.addEventListener('change', (e) => {
    if (e.target.matches('input[name="updates[]"]')) {
      setTimeout(updateFreeShipping, 300);
    }
  });

  document.addEventListener('click', (e) => {
    if (
      e.target.closest('.quantity__button') ||
      e.target.closest('[name="plus"]') ||
      e.target.closest('[name="minus"]')
    ) {
      setTimeout(updateFreeShipping, 300);
    }
  });
  
  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    const url = args[0];

    if (
      typeof url === 'string' &&
      (url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/add'))
    ) {
      setTimeout(updateFreeShipping, 200);
    }

    return response;
  };
});

// Cart - remove minimun quantity - Remove item when 0
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('quantity-input.cart-quantity').forEach((quantityInput) => {
    const input = quantityInput.querySelector('.quantity__input');
    const minus = quantityInput.querySelector('[name="minus"]');
    const cartItem = quantityInput.closest('.cart-item');
    const confirmation = cartItem?.querySelector(
      '.cart-remove-confirmation'
    );
    const cancelButton = confirmation?.querySelector(
      '.cart-remove-confirmation__cancel'
    );
    const removeButton = confirmation?.querySelector(
      '.cart-remove-confirmation__remove'
    );

    if (!input || !confirmation) return;

    function showRemoveConfirmation() {
      input.value = 1;

      confirmation.hidden = false;
      confirmation.classList.add('active');
    }

    function hideRemoveConfirmation() {
      confirmation.hidden = true;
      confirmation.classList.remove('active');
    }

    function removeProduct() {
      const lineKey = input.dataset.quantityLineKey;

      if (!lineKey) return;

      removeButton.disabled = true;
      confirmation.classList.add('loading');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: 0
        })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Could not remove item');
        }

        return response.json();
      })
      .then(() => {
        window.location.reload();
      })
      .catch(error => {
        console.error(error);

        removeButton.disabled = false;
        confirmation.classList.remove('loading');
      });
    }

    if (minus) {
      minus.addEventListener('click', (event) => {

        const current = parseInt(input.value, 10);

        if (current === 1) {
          event.preventDefault();
          event.stopImmediatePropagation();

          showRemoveConfirmation();
        }
      }, true);
    }

    input.addEventListener('change', (event) => {

      const value = parseInt(input.value, 10);

      if (value === 0) {
        event.preventDefault();
        event.stopImmediatePropagation();

        showRemoveConfirmation();
      }
    }, true);

    cancelButton?.addEventListener('click', () => {
      input.value = 1;
      hideRemoveConfirmation();
    });

    removeButton?.addEventListener('click', () => {
      removeProduct();
    });
  });
});

document.addEventListener('click', function (e) {
  const minusBtn = e.target.closest('.quantity__button[name="minus"]');
  if (!minusBtn) return;

  const wrapper = minusBtn.closest('quantity-input');
  const input = wrapper?.querySelector('.quantity__input');

  if (!input) return;

  const current = parseInt(input.value, 10);

  if (current === 1) {
    e.preventDefault();

    const lineKey = input.dataset.quantityLineKey;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineKey,
        quantity: 0
      })
    })
    .then(() => {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
  }
});

// Cart item size selection
document.addEventListener('change', function (e) {
  if (!e.target.matches('.cart-size-selector')) return;

  const select = e.target;
  const newVariantId = parseInt(select.value, 10);
  const lineKey = select.dataset.lineKey;

  if (!newVariantId || !lineKey) return;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      const item = cart.items.find(i => i.key === lineKey);
      if (!item) return;

      const quantity = item.quantity;

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: lineKey,
          quantity: 0
        })
      })
      .then(() => {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: newVariantId,
            quantity: quantity
          })
        });
      });
    })
    .then(() => {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
});

// Cart total
function updateCartTotal() {
  const totalElement = document.querySelector('[data-cart-total]');
  if (!totalElement) return;

  fetch(`${window.Shopify.routes.root}cart.js`)
    .then(response => response.json())
    .then(cart => {
      const shippingCost =
        parseInt(totalElement.dataset.shippingCost, 10) || 0;

      const total = cart.total_price + shippingCost;

      totalElement.textContent =
        '$' +
        new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(total / 100);
    })
    .catch(error => {
      console.error('Error updating cart total:', error);
    });
}

const cartContainer = document.querySelector('cart-items');

if (cartContainer) {
  const observer = new MutationObserver(() => {
    updateCartTotal();
  });

  observer.observe(cartContainer, {
    childList: true,
    subtree: true
  });
}

// Update cart counter
function wishlistCartSectionIds() {
  const cart = document.querySelector('cart-notification') ||
    document.querySelector('cart-drawer');
  const ids = [];

  if (cart && typeof cart.getSectionsToRender === 'function') {
    cart.getSectionsToRender().forEach(section => {
      if (section && section.id && !ids.includes(section.id)) {
        ids.push(section.id);
      }
    });
  }

  if (!ids.includes('cart-icon-bubble')) {
    ids.push('cart-icon-bubble');
  }

  return ids.join(',');
}

function applyCartSectionHTML(target, html) {
  if (!target || !html) return;

  const parsed = new DOMParser().parseFromString(html, 'text/html');
  const section = parsed.querySelector('.shopify-section');

  target.innerHTML = section ? section.innerHTML : html;
}

function applyCartIconSection(payload) {
  const html = payload &&
    payload.sections &&
    payload.sections['cart-icon-bubble'];
  const icon = document.getElementById('cart-icon-bubble');

  applyCartSectionHTML(icon, html);
}

function writeCartCounters(count) {
  if (count == null || Number.isNaN(Number(count))) return;

  const text = String(count);

  document.querySelectorAll('[data-cart-count]').forEach(counter => {
    counter.textContent = text;
  });

  document.querySelectorAll('.cart-count-bubble').forEach(bubble => {
    const visible = bubble.querySelector('[aria-hidden="true"]');

    if (visible) {
      visible.textContent = text;
    }
  });
}

async function readCartItemCount(payload) {
  if (
    payload &&
    payload.item_count != null &&
    !Number.isNaN(Number(payload.item_count))
  ) {
    return Number(payload.item_count);
  }

  const response = await fetch(
    `${window.Shopify.routes.root}cart.js`,
    { headers: { Accept: 'application/json' } }
  );

  if (!response.ok) return null;

  const cart = await response.json();

  return cart.item_count;
}

async function refreshCartIconBubble() {
  const icon = document.getElementById('cart-icon-bubble');

  if (!icon || !window.Shopify || !window.Shopify.routes) return;

  try {
    const response = await fetch(
      `${window.Shopify.routes.root}?sections=cart-icon-bubble`
    );

    if (!response.ok) return;

    const data = await response.json();

    applyCartSectionHTML(icon, data['cart-icon-bubble']);
  } catch (error) {
    console.error('Unable to update cart icon:', error);
  }
}

async function updateCartCount() {
  try {
    const count = await readCartItemCount();

    await refreshCartIconBubble();
    writeCartCounters(count);
  } catch (error) {
    console.error('Unable to update cart count:', error);
  }
}

window.updateCartCount = updateCartCount;

document.addEventListener('cart:refresh', updateCartCount);
document.addEventListener('cart:updated', updateCartCount);
document.addEventListener('cart:update', updateCartCount);

// Product gallery zoom
function initProductGalleryZoom() {
  document.querySelectorAll('media-gallery').forEach(gallery => {
    if (gallery.dataset.galleryZoomReady === 'true') return;

    const toggle = gallery.querySelector('[data-gallery-zoom-toggle]');
    const controls = gallery.querySelector('.product-gallery-zoom');
    const minus = gallery.querySelector('[data-zoom-minus]');
    const plus = gallery.querySelector('[data-zoom-plus]');
    const value = gallery.querySelector('[data-zoom-value]');
    const mediaItems = gallery.querySelectorAll('.product__media-item');

    if (!toggle || !controls || !minus || !plus || !value || !mediaItems.length) return;

    gallery.dataset.galleryZoomReady = 'true';

    const zoomLevels = [100, 200, 300];
    let zoomIndex = 0;

    function setMediaWidth(zoom) {
      gallery.querySelectorAll('.product__media-item').forEach(item => {
        item.style.setProperty(
          '--gallery-image-width',
          `${zoom}%`
        );
      });
    }

    function updateZoom() {
      const zoom = zoomLevels[zoomIndex];

      setMediaWidth(zoom);

      value.textContent = `${zoom}%`;

      minus.disabled = zoomIndex === 0;
      plus.disabled = zoomIndex === zoomLevels.length - 1;

      gallery.classList.remove(
        'zoomed-100',
        'zoomed-200',
        'zoomed-300'
      );

      gallery.classList.add(`zoomed-${zoom}`);
    }

    function resetZoom() {
      zoomIndex = 0;

      setMediaWidth(50);

      value.textContent = '100%';

      minus.disabled = true;
      plus.disabled = false;

      gallery.classList.remove(
        'zoomed-100',
        'zoomed-200',
        'zoomed-300'
      );
    }

    toggle.addEventListener('click', () => {
      const isOpen = controls.classList.toggle('active');

      toggle.setAttribute(
        'aria-expanded',
        isOpen ? 'true' : 'false'
      );

      if (isOpen) {
        zoomIndex = 0;
        updateZoom();
      } else {
        resetZoom();
      }
    });

    minus.addEventListener('click', () => {
      if (zoomIndex === 0) return;

      zoomIndex--;
      updateZoom();
    });

    plus.addEventListener('click', () => {
      if (zoomIndex === zoomLevels.length - 1) return;

      zoomIndex++;
      updateZoom();
    });

    resetZoom();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductGalleryZoom);
} else {
  initProductGalleryZoom();
}

// Back to top
const backToTop = document.querySelector('[data-back-to-top]');

if (backToTop) {
  const toggleBackToTop = () => {
    backToTop.classList.toggle('visible', window.scrollY > 500);
  };

  window.addEventListener('scroll', toggleBackToTop, { passive: true });

  backToTop.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });

  toggleBackToTop();
}

(function () {
  if (window.__collectionGridLayoutInit) {
    if (window.restoreProductGridLayout) window.restoreProductGridLayout();
    return;
  }

  window.__collectionGridLayoutInit = true;

  var LAYOUTS = [
    'grid--masonry-col-desktop',
    'grid--4-col-desktop',
    'grid--6-col-desktop',
    'grid--10-col-desktop'
  ];
  var DEFAULT_LAYOUT = 'grid--masonry-col-desktop';
  var STORAGE_KEY = 'collectionGridLayout';

  function readLayout() {
    var saved = '';

    try {
      saved = localStorage.getItem(STORAGE_KEY) || '';
    } catch (error) {}

    return LAYOUTS.indexOf(saved) === -1 ? DEFAULT_LAYOUT : saved;
  }

  function ensurePaintRule(layout) {
    var style = document.getElementById('collection-layout-critical');

    if (!style) {
      style = document.createElement('style');
      style.id = 'collection-layout-critical';
      (document.head || document.documentElement).appendChild(style);
    }

    var css = '';

    if (layout !== 'grid--masonry-col-desktop') {
      css += 'html[data-collection-layout="' + layout + '"] #product-grid [data-grid-module]{display:none}';
    }

    if (layout === 'grid--10-col-desktop') {
      css += 'html[data-collection-layout="grid--10-col-desktop"] #product-grid [data-card-media-slider],html[data-collection-layout="grid--10-col-desktop"] #product-grid .card-media-slider{display:none}';
      css += 'html[data-collection-layout="grid--10-col-desktop"] #product-grid [data-packshot-media]{display:block}';
    } else {
      css += 'html[data-collection-layout="' + layout + '"] #product-grid [data-packshot-media]{display:none}';
    }

    style.textContent = css;
  }

  function syncEditorialVideos(grid) {
    if (!grid) return;

    var editorial = grid.classList.contains('grid--masonry-col-desktop') && !grid.hasAttribute('data-filters-active');

    if (!window.__collectionGridVideoObserver) {
      window.__collectionGridVideoObserver = new IntersectionObserver(function (entries) {
        var current = document.getElementById('product-grid');
        var allow = current && current.classList.contains('grid--masonry-col-desktop') && !current.hasAttribute('data-filters-active');

        entries.forEach(function (entry) {
          entry.target.querySelectorAll('video').forEach(function (video) {
            if (entry.isIntersecting && allow && video.dataset.userPaused !== 'true') {
              var pending = video.play();
              if (pending && pending.catch) pending.catch(function () {});
            } else {
              video.pause();
            }
          });
        });
      }, { rootMargin: '200px 0px' });
    }

    grid.querySelectorAll('[data-grid-module]').forEach(function (module) {
      if (!module.querySelector('video') || module.dataset.editorialVideoObserved === 'true') return;

      module.dataset.editorialVideoObserved = 'true';
      window.__collectionGridVideoObserver.observe(module);
    });

    if (!editorial) {
      grid.querySelectorAll('[data-grid-module] video').forEach(function (video) {
        video.pause();
      });
    }
  }

  function applyLayout(layout, persist) {
    if (LAYOUTS.indexOf(layout) === -1) return;

    document.documentElement.dataset.collectionLayout = layout;
    ensurePaintRule(layout);

    var grid = document.getElementById('product-grid');

    if (grid) {
      LAYOUTS.forEach(function (name) {
        grid.classList.remove(name);
      });
      grid.classList.remove('grid--editorial-layout', 'is-packshot');
      grid.classList.add(layout);

      if (layout === 'grid--masonry-col-desktop') {
        grid.classList.add('grid--editorial-layout');
      }

      if (layout === 'grid--10-col-desktop') {
        grid.classList.add('is-packshot');
      }

      syncEditorialVideos(grid);
    }

    document.querySelectorAll('[data-grid-layout]').forEach(function (button) {
      var isActive = button.getAttribute('data-grid-layout') === layout;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (persist) {
      try {
        localStorage.setItem(STORAGE_KEY, layout);
      } catch (error) {}
    }
  }

  function setProductGridLayout(layout) {
    applyLayout(layout, true);
  }

  function restoreProductGridLayout() {
    applyLayout(readLayout(), false);
  }

  window.setProductGridLayout = setProductGridLayout;
  window.restoreProductGridLayout = restoreProductGridLayout;

  if (!window.__collectionGridLayoutBound) {
    window.__collectionGridLayoutBound = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-grid-layout]');
      if (!button) return;

      event.preventDefault();
      setProductGridLayout(button.getAttribute('data-grid-layout'));
    });

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest && event.target.closest('[data-grid-module] .video-toggle');
      if (!toggle) return;

      var module = toggle.closest('[data-grid-module]');
      var video = module && module.querySelector('video');
      if (!video) return;

      event.preventDefault();

      if (video.paused) {
        video.dataset.userPaused = 'false';
        var pending = video.play();
        if (pending && pending.catch) pending.catch(function () {});
        toggle.setAttribute('aria-label', 'Pause video');
      } else {
        video.dataset.userPaused = 'true';
        video.pause();
        toggle.setAttribute('aria-label', 'Play video');
      }
    });

    document.addEventListener('shopify:section:load', restoreProductGridLayout);
  }

  restoreProductGridLayout();

  if (!document.getElementById('product-grid')) {
    var observer = new MutationObserver(function () {
      if (!document.getElementById('product-grid')) return;
      observer.disconnect();
      restoreProductGridLayout();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

// Collection - load more
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-load-more]');
  if (!button) return;

  event.preventDefault();

  const wrapper = button.closest('[data-load-more-wrapper]');
  const productGrid = document.querySelector('#product-grid');

  if (!wrapper || !productGrid) return;

  const nextUrl = button.href;

  button.classList.add('loading');
  button.setAttribute('aria-disabled', 'true');

  try {
    const response = await fetch(nextUrl);

    if (!response.ok) {
      throw new Error(`HTTP error: ${response.status}`);
    }

    const html = await response.text();

    const parser = new DOMParser();
    const nextDocument = parser.parseFromString(html, 'text/html');

    const nextGrid = nextDocument.querySelector('#product-grid');

    if (!nextGrid) {
      throw new Error('Product grid not found');
    }
    
    const currentGroup = productGrid.querySelector('.collection-layout-group--default .collection-layout-group__grid');
    const nextGroup = nextGrid.querySelector('.collection-layout-group--default .collection-layout-group__grid');

    if (currentGroup && nextGroup) {
      Array.from(nextGroup.children).forEach((item) => {
        currentGroup.appendChild(item);
      });
    } else {
      Array.from(nextGrid.children).forEach((item) => {
        if (item.matches('[data-grid-module]')) return;
        productGrid.appendChild(item);
      });
    }

    if (typeof window.restoreProductGridLayout === 'function') {
      window.restoreProductGridLayout();
    }

    if (typeof filterVariantCards === 'function') filterVariantCards();
    if (typeof initializeAllMediaDots === 'function') initializeAllMediaDots();

    const nextPagination = nextDocument.querySelector(
      '[data-load-more-wrapper]'
    );

    if (nextPagination) {
      wrapper.replaceWith(nextPagination);
    } else {
      wrapper.remove();
    }

  } catch (error) {
    console.error('Error loading more products:', error);

    button.classList.remove('loading');
    button.removeAttribute('aria-disabled');
  }
});

// AC White header on scroll
const myElement = document.querySelector('.section-header');

window.addEventListener('scroll', () => {
  if (window.scrollY > 50) {
    myElement.classList.add('scrolled');
  } else {
    myElement.classList.remove('scrolled');
  }
});

// Scrollbar
function initMediaDots({
  gallerySelector,
  sliderSelector,
  slideSelector,
  dotsSelector,
  hiddenClass = 'is-hidden-by-color'
}) {
  document.querySelectorAll(gallerySelector).forEach((gallery) => {
    const slider = gallery.matches(sliderSelector)
      ? gallery
      : gallery.querySelector(sliderSelector);
    const dotsWrapper = gallery.querySelector(dotsSelector);

    if (!slider || !dotsWrapper) return;

    if (gallery.dataset.mediaDotsInitialized === 'true') {
      gallery._rebuildMediaDots?.();
      return;
    }

    gallery.dataset.mediaDotsInitialized = 'true';

    function getVisibleSlides() {
      return Array.from(gallery.querySelectorAll(slideSelector)).filter((slide) => {
        return !slide.classList.contains(hiddenClass) && !slide.hidden && slide.offsetParent !== null;
      });
    }

    function updateActiveDot() {
      const slides = getVisibleSlides();
      const dots = Array.from(dotsWrapper.children);

      if (!slides.length || !dots.length) return;

      const sliderRect = slider.getBoundingClientRect();
      const sliderCenter = sliderRect.left + sliderRect.width / 2;
      let activeIndex = 0;
      let smallestDistance = Infinity;

      slides.forEach((slide, index) => {
        const slideRect = slide.getBoundingClientRect();
        const slideCenter = slideRect.left + slideRect.width / 2;
        const distance = Math.abs(sliderCenter - slideCenter);

        if (distance < smallestDistance) {
          smallestDistance = distance;
          activeIndex = index;
        }
      });

      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);

        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function createDots() {
      const slides = getVisibleSlides();

      dotsWrapper.innerHTML = '';
      dotsWrapper.hidden = slides.length <= 1;

      slides.forEach((slide, index) => {
        const dot = document.createElement('button');

        dot.type = 'button';
        dot.className = 'slider-counter__link slider-counter__link--dots link';
        dot.setAttribute('aria-label', `Show media ${index + 1} of ${slides.length}`);
        dot.innerHTML = '<span class="dot"></span>';

        dot.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const sliderRect = slider.getBoundingClientRect();
          const slideRect = slide.getBoundingClientRect();
          const targetLeft = slider.scrollLeft + slideRect.left - sliderRect.left;

          slider.scrollTo({
            left: targetLeft,
            behavior: 'smooth'
          });
        });

        dotsWrapper.appendChild(dot);
      });

      updateActiveDot();
    }

    let ticking = false;

    slider.addEventListener('scroll', () => {
      if (ticking) return;

      ticking = true;

      requestAnimationFrame(() => {
        updateActiveDot();
        ticking = false;
      });
    }, { passive: true });

    window.addEventListener('resize', updateActiveDot);

    gallery._rebuildMediaDots = createDots;
    gallery._updateActiveMediaDot = updateActiveDot;

    createDots();
  });
}

function initProductMediaDots() {
  initMediaDots({
    gallerySelector: 'media-gallery',
    sliderSelector: '.product__media-list',
    slideSelector: '.product__media-item',
    dotsSelector: '.product-media-dots'
  });
}

function initCardMediaDots() {
  initMediaDots({
    gallerySelector: '[data-card-media-slider]',
    sliderSelector: '[data-card-media-viewport]',
    slideSelector: '[data-card-media-slide]',
    dotsSelector: '[data-card-media-dots]'
  });
}

function initializeAllMediaDots() {
  initProductMediaDots();
  initCardMediaDots();
}

function rebuildAllMediaDots() {
  document.querySelectorAll('media-gallery, [data-card-media-slider]').forEach((gallery) => {
    gallery._rebuildMediaDots?.();
  });
}

window.initMediaDots = initMediaDots;
window.initProductMediaDots = initProductMediaDots;
window.initCardMediaDots = initCardMediaDots;
window.initializeAllMediaDots = initializeAllMediaDots;
window.rebuildAllMediaDots = rebuildAllMediaDots;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAllMediaDots);
} else {
  initializeAllMediaDots();
}

document.addEventListener('shopify:section:load', initializeAllMediaDots);

document.addEventListener('media-dots:refresh', () => {
  initializeAllMediaDots();
  rebuildAllMediaDots();
});

// Customer service dropdown
function initLegalDropdowns() {
  document.querySelectorAll('[data-legal-dropdown]').forEach((dropdown) => {
    if (dropdown.dataset.initialized === 'true') return;

    const trigger = dropdown.querySelector('[data-legal-dropdown-trigger]');

    if (!trigger) return;

    dropdown.dataset.initialized = 'true';

    trigger.addEventListener('click', () => {
      const isOpen = dropdown.classList.toggle('is-open');

      trigger.setAttribute(
        'aria-expanded',
        isOpen ? 'true' : 'false'
      );
    });
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-legal-dropdown].is-open').forEach((dropdown) => {
      if (dropdown.contains(event.target)) return;

      dropdown.classList.remove('is-open');

      dropdown
        .querySelector('[data-legal-dropdown-trigger]')
        ?.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-legal-dropdown].is-open').forEach((dropdown) => {
      dropdown.classList.remove('is-open');

      dropdown
        .querySelector('[data-legal-dropdown-trigger]')
        ?.setAttribute('aria-expanded', 'false');
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLegalDropdowns);
} else {
  initLegalDropdowns();
}

// Legal pages reuse the size-guide control markup
// (data-size-guide-trigger="legal" / data-size-guide-menu="legal").
// The size-guide section script is not in this file and only runs on that
// section, so it never reaches FAQ pages. Bind the legal key here.
// Gender stays with the size-guide section. [data-legal-dropdown] stays
// with initLegalDropdowns above.
function setSizeGuideLegalOpen(control, open) {
  const trigger = control.querySelector('[data-size-guide-trigger="legal"]');
  const menu = control.querySelector('[data-size-guide-menu="legal"]');

  if (!trigger || !menu) return;

  menu.hidden = !open;
  trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  control.classList.toggle('is-open', open);
  trigger.classList.toggle('is-open', open);
  menu.classList.toggle('is-open', open);
}

function closeSizeGuideLegalMenus() {
  document.querySelectorAll('.size-guide-control').forEach((control) => {
    if (!control.querySelector('[data-size-guide-trigger="legal"]')) return;

    setSizeGuideLegalOpen(control, false);
  });
}

function initSizeGuideLegalMenu() {
  document.querySelectorAll('[data-size-guide-trigger="legal"]').forEach((trigger) => {
    if (trigger.dataset.sizeGuideLegalBound === 'true') return;

    const control = trigger.closest('.size-guide-control');
    const menu = control?.querySelector('[data-size-guide-menu="legal"]');

    if (!control || !menu) return;

    trigger.dataset.sizeGuideLegalBound = 'true';

    trigger.addEventListener('click', () => {
      const willOpen = menu.hidden;

      closeSizeGuideLegalMenus();

      if (willOpen) {
        setSizeGuideLegalOpen(control, true);
      }
    });
  });
}

document.addEventListener('click', (event) => {
  document.querySelectorAll('.size-guide-control').forEach((control) => {
    if (!control.querySelector('[data-size-guide-trigger="legal"]')) return;
    if (control.contains(event.target)) return;

    setSizeGuideLegalOpen(control, false);
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  closeSizeGuideLegalMenus();
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSizeGuideLegalMenu);
} else {
  initSizeGuideLegalMenu();
}

document.addEventListener('shopify:section:load', initSizeGuideLegalMenu);

// Notify me drawer
(function () {
  'use strict';

  var ACTIVE_CLASS = 'active';
  var ERROR_VISIBLE_CLASS = 'is-visible';
  var INPUT_INVALID_CLASS = 'invalid';
  var SUBMIT_INCOMPLETE_CLASS = 'is-incomplete';

  var MESSAGES = {
    emailRequired: 'Introduce tu correo electrónico.',
    emailInvalid: 'El formato de correo no es válido (ejemplo: nombre@dominio.com).',
    phoneInvalid: 'Introduce un número de teléfono válido a 10 dígitos.',
    termsRequired: 'Debes aceptar los términos para continuar.',
    submitFailed: 'No pudimos registrar tu solicitud. Vuelve a intentarlo.'
  };

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;
  var MX_PHONE_SHAPE_RE = /^\s*(?:00)?(?:\+?52|0(?:44|45|1|2))?[\s().\-]*(?:1[\s().\-]*)?(?:[\s().\-]*\d){10}[\s.\-]*$/;

  function isValidEmail(value) {
    var email = String(value == null ? '' : value).trim();
    if (email === '' || email.length > 254) return false;
    return EMAIL_RE.test(email);
  }
  
  function normalizeMxPhone(raw) {
    if (raw == null) return null;

    var value = String(raw);
    if (value.trim() === '') return null;
    if (!MX_PHONE_SHAPE_RE.test(value)) return null;

    var hadPlus = /^\s*\+/.test(value);
    var digits = value.replace(/\D/g, '');

    if (digits.indexOf('00') === 0) {
      digits = digits.slice(2);
    } else if (!hadPlus) {
      digits = digits.replace(/^0(?:44|45|1|2)/, '');
    }

    var hadCountryCode = false;
    if (digits.length > 10 && digits.indexOf('52') === 0) {
      digits = digits.slice(2);
      hadCountryCode = true;
    } else if (hadPlus) {
      return null;
    }

    if (hadCountryCode && digits.length === 11 && digits.charAt(0) === '1') {
      digits = digits.slice(1);
    }

    if (!/^[2-9]\d{9}$/.test(digits) || digits.indexOf('911') === 0) return null;

    return '+52' + digits;
  }

  function validateNotifyForm(values) {
    var email = String(values && values.email != null ? values.email : '').trim();
    var phone = String(values && values.phone != null ? values.phone : '').trim();
    var terms = !!(values && values.terms);

    var errors = { email: null, phone: null, terms: null };

    if (email === '') {
      errors.email = MESSAGES.emailRequired;
    } else if (!isValidEmail(email)) {
      errors.email = MESSAGES.emailInvalid;
    }

    var phoneE164 = null;
    if (phone !== '') {
      phoneE164 = normalizeMxPhone(phone);
      if (!phoneE164) errors.phone = MESSAGES.phoneInvalid;
    }

    if (!terms) errors.terms = MESSAGES.termsRequired;

    return {
      valid: !errors.email && !errors.phone && !errors.terms,
      errors: errors,
      email: email,
      phone: phone,
      phoneE164: phoneE164
    };
  }

  function submitNotifyRequest(payload) {
    if (window.console && console.info) {
      console.info('[notify-drawer] submission (stub, not stored):', payload);
    }
    return Promise.resolve({ stubbed: true });
  }

  function getDrawer() {
    return document.querySelector('.notify-drawer');
  }

  function showError(field, message) {
    if (!field) return;
    var text = field.querySelector('[data-error-text]');
    if (text) text.textContent = message;
    field.hidden = false;
    field.classList.add(ERROR_VISIBLE_CLASS);
  }

  function hideError(field) {
    if (!field) return;
    field.hidden = true;
    field.classList.remove(ERROR_VISIBLE_CLASS);
  }

  function clearAllErrors(form) {
    if (!form) return;
    ['[data-error-email]', '[data-error-phone]', '[data-error-terms]', '[data-error-form]'].forEach(
      function (selector) {
        hideError(form.querySelector(selector));
      }
    );
    form.querySelectorAll('.' + INPUT_INVALID_CLASS).forEach(function (input) {
      input.classList.remove(INPUT_INVALID_CLASS);
      input.removeAttribute('aria-invalid');
    });
  }

  function markInvalid(input, invalid) {
    if (!input) return;
    input.classList.toggle(INPUT_INVALID_CLASS, invalid);
    if (invalid) {
      input.setAttribute('aria-invalid', 'true');
    } else {
      input.removeAttribute('aria-invalid');
    }
  }

  function syncSubmitState(form) {
    var terms = form.querySelector('[data-notify-terms]');
    var submit = form.querySelector('[data-notify-submit]');
    if (!submit) return;
    submit.classList.toggle(SUBMIT_INCOMPLETE_CLASS, !(terms && terms.checked));
  }

  function getProductData(drawer) {
    if (!drawer) return null;
    if (drawer._notifyProductData !== undefined) return drawer._notifyProductData;

    var node = drawer.querySelector('[data-notify-product-data]');
    var parsed = null;
    if (node) {
      try {
        parsed = JSON.parse(node.textContent);
      } catch (error) {
        console.error('[notify-drawer] could not parse product data:', error);
      }
    }
    drawer._notifyProductData = parsed;
    return parsed;
  }

  function findVariant(drawer, variantId) {
    var data = getProductData(drawer);
    if (!data || !data.variants || variantId == null || variantId === '') return null;
    return data.variants[String(variantId)] || null;
  }

  function renderConfirmation(drawer, form, result) {
    var panel = drawer.querySelector('[data-notify-success]');
    if (!panel) return;

    var data = getProductData(drawer);
    var variant = findVariant(drawer, drawer.dataset.variantId);

    var title = (variant && variant.productTitle) || (data && data.title) || '';
    var image = (variant && variant.image) || (data && data.image) || '';
    var price = (variant && variant.price) || '';

    var variantLabel = (variant && variant.title) || '';
    if (!variantLabel) {
      variantLabel = [drawer.dataset.color, drawer.dataset.size]
        .filter(function (part) { return part; })
        .join(' / ');
    }

    var imageEl = panel.querySelector('[data-out-image]');
    if (imageEl) {
      if (image) {
        imageEl.src = image;
        imageEl.alt = title;
        imageEl.hidden = false;
      } else {
        imageEl.hidden = true;
      }
    }

    var titleEl = panel.querySelector('[data-out-title]');
    if (titleEl) titleEl.textContent = title;

    var variantEl = panel.querySelector('[data-out-variant]');
    if (variantEl) variantEl.textContent = variantLabel;

    var priceEl = panel.querySelector('[data-out-price]');
    if (priceEl) priceEl.textContent = price;

    var emailEl = panel.querySelector('[data-out-email]');
    if (emailEl) emailEl.textContent = result.email;

    var phoneRow = panel.querySelector('[data-out-phone-row]');
    var phoneEl = panel.querySelector('[data-out-phone]');
    if (phoneRow) phoneRow.hidden = !result.phone;
    if (phoneEl) phoneEl.textContent = result.phone || '';

    var intro = drawer.querySelector('[data-notify-intro]');
    if (intro) intro.hidden = true;

    form.hidden = true;
    panel.hidden = false;

    if (typeof panel.focus === 'function') panel.focus();
  }

  var justOpened = false;

  window.openNotifyDrawer = function (data) {
    data = data || {};

    var drawer = getDrawer();
    if (!drawer) return;

    var productHandle = data.productHandle || '';
    var variantId = data.variantId || '';
    var size = data.size || '';
    var color = data.color || '';

    Object.assign(drawer.dataset, {
      productHandle: productHandle,
      variantId: variantId,
      size: size,
      color: color
    });

    var variant = findVariant(drawer, variantId);
    var sizeLabel = (variant && variant.size) || size;
    var colorLabel = (variant && variant.color) || color;

    var sizeOutput = drawer.querySelector('[data-selected-value]');
    if (sizeOutput) sizeOutput.textContent = sizeLabel;

    var sizeRow = drawer.querySelector('[data-selected-size-row]');
    if (sizeRow) sizeRow.hidden = !sizeLabel;

    var colorOutput = drawer.querySelector('[data-selected-color]');
    if (colorOutput) colorOutput.textContent = colorLabel;

    var colorRow = drawer.querySelector('[data-selected-color-row]');
    if (colorRow) colorRow.hidden = !colorLabel;

    var form = drawer.querySelector('[data-notify-form]');
    var panel = drawer.querySelector('[data-notify-success]');

    if (form) {
      form.hidden = false;
      form.reset();
      clearAllErrors(form);
      syncSubmitState(form);
      form.querySelectorAll('.notify-form-input').forEach(function (input) {
        input.classList.toggle('filled', input.value.trim() !== '');
      });
    }
    if (panel) panel.hidden = true;

    var intro = drawer.querySelector('[data-notify-intro]');
    if (intro) intro.hidden = false;

    drawer.classList.add(ACTIVE_CLASS);

    justOpened = true;
    window.setTimeout(function () { justOpened = false; }, 0);
  };

  function closeDrawer(drawer) {
    if (drawer) drawer.classList.remove(ACTIVE_CLASS);
  }

  document.addEventListener('click', function (event) {
    var drawer = document.querySelector('.notify-drawer.' + ACTIVE_CLASS);
    if (!drawer || justOpened) return;

    var isCloseButton = event.target.closest('.drawer__close');
    var clickedInsideContent = event.target.closest('.notify-drawer__inner-content');

    if (isCloseButton || !clickedInsideContent) closeDrawer(drawer);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var drawer = document.querySelector('.notify-drawer.' + ACTIVE_CLASS);
    if (drawer) closeDrawer(drawer);
  });

  function handleFieldState(event) {
    var target = event.target;
    if (!target || !target.classList) return;

    if (target.classList.contains('notify-form-input')) {
      target.classList.toggle('filled', target.value.trim() !== '');
    }

    var form = target.closest('[data-notify-form]');
    if (!form) return;

    syncSubmitState(form);
    
    if (target.matches('[data-notify-email]')) {
      hideError(form.querySelector('[data-error-email]'));
      markInvalid(target, false);
    } else if (target.matches('[data-notify-phone]')) {
      hideError(form.querySelector('[data-error-phone]'));
      markInvalid(target, false);
    } else if (target.matches('[data-notify-terms]')) {
      if (target.checked) hideError(form.querySelector('[data-error-terms]'));
    }
  }

  document.addEventListener('input', handleFieldState);
  document.addEventListener('change', handleFieldState);

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-notify-form]');
    if (!form) return;

    event.preventDefault();

    var drawer = form.closest('.notify-drawer');
    var emailInput = form.querySelector('[data-notify-email]');
    var phoneInput = form.querySelector('[data-notify-phone]');
    var termsInput = form.querySelector('[data-notify-terms]');
    var submitButton = form.querySelector('[data-notify-submit]');

    hideError(form.querySelector('[data-error-form]'));

    var result = validateNotifyForm({
      email: emailInput ? emailInput.value : '',
      phone: phoneInput ? phoneInput.value : '',
      terms: termsInput ? termsInput.checked : false
    });

    markInvalid(emailInput, !!result.errors.email);
    markInvalid(phoneInput, !!result.errors.phone);

    if (result.errors.email) {
      showError(form.querySelector('[data-error-email]'), result.errors.email);
    } else {
      hideError(form.querySelector('[data-error-email]'));
    }

    if (result.errors.phone) {
      showError(form.querySelector('[data-error-phone]'), result.errors.phone);
    } else {
      hideError(form.querySelector('[data-error-phone]'));
    }

    if (result.errors.terms) {
      showError(form.querySelector('[data-error-terms]'), result.errors.terms);
    } else {
      hideError(form.querySelector('[data-error-terms]'));
    }

    if (!result.valid) {
      var firstInvalid = result.errors.email
        ? emailInput
        : result.errors.phone
          ? phoneInput
          : termsInput;
      if (firstInvalid && typeof firstInvalid.focus === 'function') firstInvalid.focus();
      return;
    }

    if (form.dataset.submitting === 'true') return;
    form.dataset.submitting = 'true';
    if (submitButton) submitButton.setAttribute('aria-busy', 'true');

    var payload = {
      email: result.email,
      phone: result.phoneE164 || '',
      phoneEntered: result.phone,
      acceptsMarketing: true,
      variantId: drawer ? drawer.dataset.variantId || '' : '',
      productHandle: drawer ? drawer.dataset.productHandle || '' : '',
      size: drawer ? drawer.dataset.size || '' : '',
      color: drawer ? drawer.dataset.color || '' : ''
    };

    var send = (window.NotifyDrawer && window.NotifyDrawer.submitNotifyRequest) || submitNotifyRequest;

    Promise.resolve()
      .then(function () {
        return send(payload);
      })
      .then(function () {
        if (drawer) renderConfirmation(drawer, form, result);
      })
      .catch(function (error) {
        console.error('[notify-drawer] submission failed:', error);
        showError(form.querySelector('[data-error-form]'), MESSAGES.submitFailed);
      })
      .then(function () {
        form.dataset.submitting = 'false';
        if (submitButton) submitButton.removeAttribute('aria-busy');
      });
  });

  window.NotifyDrawer = {
    isValidEmail: isValidEmail,
    normalizeMxPhone: normalizeMxPhone,
    validateNotifyForm: validateNotifyForm,
    submitNotifyRequest: submitNotifyRequest,
    MESSAGES: MESSAGES
  };
})();